// Builds the journey's closing context and prepares the closing reflection (book + recap) once per page load,
// starting while the person reads their Purpose reveal so the finale is ready when they continue.
import { bookRecommendation, journeyRecap } from "@/services/unsaidService";
import { unsaidStore } from "@/lib/unsaidStore";
import { onboardingState } from "@/lib/onboardingState";

const purposeChat = () => { try { return JSON.parse(sessionStorage.getItem("fionova_purpose_chat") || "null")?.history || []; } catch { return []; } };

export const journeyContext = () => {
  const outcome = unsaidStore.getOutcome();
  const future = unsaidStore.getFutureOutcome()?.messages || [];
  return {
    your_words: [...(outcome?.transcript || []), ...future, ...purposeChat()].filter((m) => m.role === "user").map((m) => m.text).slice(-30),
    name: onboardingState.getAccount()?.name || "",
    unsaid: { observations: outcome?.observations || [], feedback: outcome?.feedback || "", handoff: outcome?.handoff || {} },
    xray: unsaidStore.getXrayOutcome()?.xray || {},
    plan: unsaidStore.getPlanOutcome()?.plan || {},
    future_self: future.map((m) => ({ who: m.role === "user" ? "present" : "future", text: m.text })).slice(-10),
    purpose: unsaidStore.getPurposeOutcome()?.reflection || {},
  };
};

// Everything the account keeps from this journey (applied server-side with the recap, or when a guest signs in).
export const journeyFinal = (ctx, book) => {
  const outcome = unsaidStore.getOutcome() || {};
  return {
    name: ctx.name || undefined,
    unsaid_handoff: { transcript: outcome.transcript || [], observations: outcome.observations || [], feedback: outcome.feedback || "", handoff: outcome.handoff || {} },
    xray: ctx.xray, plan: ctx.plan, purpose: ctx.purpose, book: book || undefined,
    future_self: ctx.future_self.map((m) => m.text).slice(-4),
    conversations: { future_self: ctx.future_self, purpose: purposeChat().map((m) => ({ role: m.role, text: m.text })) },
  };
};

let pending = null;

// Resolves to { status, recap, book }. Shared in-flight promise so the Purpose page and the finale never double-generate.
export const prepareFinale = () => {
  if (pending) return pending;
  pending = (async () => {
    const ctx = journeyContext();
    const b = await bookRecommendation({ purpose: ctx.purpose, handoff: ctx.unsaid.handoff, xray: ctx.xray, plan: ctx.plan,
      future_themes: ctx.future_self.map((m) => m.text).slice(-4) }).catch(() => ({}));
    const book = b?.recommend ? { title: b.title, why: b.why, link: b.link } : null;
    const res = await journeyRecap({ ...ctx, book: book?.title || null }, journeyFinal(ctx, book));
    return { status: res.status, recap: res.ok ? res.data?.recap || null : null, book };
  })();
  pending.then((r) => { if (!r.recap) pending = null; });
  return pending;
};
